export default "__VITE_ASSET__KyOUelX$__"